import generateGetTrackerSaReportInfoFunc from "~/common/tracker/generateGetTrackerSaReportInfoFunc";
export const SensorConfig = {
  //  商详页
  homePage: {
    pageInfo: {
      page_id: "1214",
      page_name: "product details page",
    },
    events: {
      // 商品图片滑动（不用区分第几个图）
      clickCarousel: {
        element_id: `12140103`,
        element_name: "picture sliding",
        moudle_id: "01",
        moudle_name: "top",
        position_id: "03",
      },
      // 点击查看商品大图
      clickBrand: {
        element_id: `12140104`,
        element_name: "big picture",
        moudle_id: "01",
        moudle_name: "top",
        position_id: "04",
      },
      // 优惠券栏目
      clickCouponPop: {
        element_id: `12140201`,
        element_name: "coupon",
        moudle_id: "02",
        moudle_name: "coupon",
        position_id: "01",
      },

      // 点击分期属性
      clickInstallment: {
        element_id: `12140301`,
        element_name: "installment",
        moudle_id: "03",
        moudle_name: "installment",
        position_id: "01",
      },
      // 点击店铺logo/名称
      clickShop: {
        element_id: `12140402`,
        element_name: "logo",
        moudle_id: "04",
        moudle_name: "shop",
        position_id: "02",
      },
      // 打开app浮窗按钮（重要按钮）
      clickOpenAPPBar: {
        element_id: `12140501`,
        element_name: "open app",
        moudle_id: "05",
        moudle_name: "bottom",
        position_id: "01",
      },
      // 立即购买按钮（重要按钮）
      clickBuy: {
        element_id: `12140502`,
        element_name: "buy now",
        moudle_id: "05",
        moudle_name: "bottom",
        position_id: "02",
      },
      // 加入购物车
      clickAddCart: {
        element_id: `12140503`,
        element_name: "add to cart",
        moudle_id: "05",
        moudle_name: "bottom",
        position_id: "03",
      },
      // 查看全部评价按钮
      clickViewAllPreview: {
        element_id: `12140601`,
        element_name: "view all reviews",
        moudle_id: "06",
        moudle_name: "reviews",
        position_id: "01",
      },
      // 点击查看图片
      clickViewPic: {
        element_id: `12140602`,
        element_name: "view picture",
        moudle_id: "06",
        moudle_name: "reviews",
        position_id: "02",
      },
      // 查看图片左右划
      swipeImg: {
        element_id: `12140604`,
        element_name: "change",
        moudle_id: "06",
        moudle_name: "reviews",
        position_id: "04",
      },
      // 查看大图返回按钮
      clickBack: {
        element_id: `12140606`,
        element_name: "return",
        moudle_id: "06",
        moudle_name: "reviews",
        position_id: "06",
      },
      // 查看大图展开按钮
      clickExpand: {
        element_id: `12140607`,
        element_name: "expand",
        moudle_id: "06",
        moudle_name: "reviews",
        position_id: "07",
      },
      // 查看大图收起按钮
      clickCollapse: {
        element_id: `12140608`,
        element_name: "collapse",
        moudle_id: "06",
        moudle_name: "reviews",
        position_id: "08",
      },
      // 点击公告栏
      clickMarketing: {
        element_id: `12140701`,
        element_name: "marketing",
        moudle_id: "07",
        moudle_name: "ad",
        position_id: "01",
      },
    },
    pops: {
      // SKU选择面板属性栏
      skuPop: {
        popInfo: {
          pop_id: `pop30270`,
          pop_name: "selection sku property",
        },
        events: {
          // sku浮窗- 更改数量
          skuChangeQut: {
            element_id: `pop3027001`,
            element_name: "change",
          },
          // sku浮窗-选择属性
          selectAttributes: {
            element_id: `pop3027003`,
            element_name: "select property",
          },
          // sku浮窗-立即购买
          clickPurchase: {
            element_id: `pop3027004`,
            element_name: "buy",
          },
          // sku浮窗-加入购物车
          clickAddCart: {
            element_id: `pop3027005`,
            element_name: "add to cart",
          },
          // sku浮窗-关闭按钮
          skuClose: {
            element_id: `pop3027006`,
            element_name: "close",
          },
          // 选择分期
          selectInstallment: {
            element_id: `pop3027007`,
            element_name: "paylater",
          },
          // 选择全款
          selectFullPayment: {
            element_id: `pop3027008`,
            element_name: "full amount",
          },
        },
      },
      // 配送地址
      addressPop: {
        popInfo: {
          pop_id: `pop30271`,
          pop_name: "select address",
        },
        events: {
          // 浮窗-关闭按钮
          clickClose: {
            element_id: `pop3027102`,
            element_name: "close",
          },
        },
      },
      // 引导打开app弹窗
      openAppPop: {
        popInfo: {
          pop_id: `pop30272`,
          pop_name: "guide to open app",
        },
        events: {
          // 点击打开按钮
          clickOpen: {
            element_id: `pop3027201`,
            element_name: "open",
          },
          // 浮窗-关闭按钮
          clickClose: {
            element_id: `pop3027202`,
            element_name: "close",
          },
        },
      },
      // 曝光 店铺优惠券-店铺优惠券弹窗
      couponPop: {
        popInfo: {
          pop_id: `pop30274`,
          pop_name: "coupon",
        },
        events: {
          // 优惠券浮窗-关闭按钮
          clickCouponClose: {
            pop_id: `pop30274`,
            pop_name: "coupon",
            element_id: `pop3027401`,
            element_name: "close",
          },
          // 优惠券浮窗-点击唤起下载弹窗
          clickCoupon: {
            pop_id: `pop30274`,
            pop_name: "coupon",
            element_id: `pop3027402`,
            element_name: "download",
          },
        },
      },
      // 挽留弹窗
      redeemPop: {
        popInfo: {
          pop_id: `pop30273`,
          pop_name: "retain popup",
        },
        events: {
          // 弹窗点击“下次再说”
          clickCancel: {
            pop_id: `pop30273`,
            pop_name: "retain popup",
            element_id: `pop3027301`,
            element_name: "next time",
          },
          // 弹窗点击“去看看”
          clickDownApp: {
            pop_id: `pop30273`,
            pop_name: "retain popup",
            element_id: `pop3027302`,
            element_name: "cancel",
          },
        },
      },
    },
  },
};

export const getTrackerSaReportInfo = generateGetTrackerSaReportInfoFunc(SensorConfig);
